export default __webpack_public_path__ + "78357ac.png";